import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "Absolute-Center is-Responsive" }
const _hoisted_4 = { class: "card transparencia" }
const _hoisted_5 = { class: "card-block" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-primary text-white text-center" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "SMS")
], -1)
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_10 = { class: "container" }
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  for: "emailu",
  class: "form-label"
}, "Usuario", -1)
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: "passwordu",
  class: "form-label"
}, "Password", -1)
const _hoisted_15 = { id: "formulario" }
const _hoisted_16 = { class: "form-group mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("img", {
                src: require('../img/logo-aguademexico-horizontal.png'),
                width: "",
                style: {"background-color":"transparent"},
                alt: "",
                class: "img-rounded img-thumbnail center-block"
              }, null, 8, _hoisted_8),
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("form", {
                  onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.loginUploader && _ctx.loginUploader(...args)), ["prevent"]))
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      class: "form-control",
                      id: "emailu",
                      "aria-describedby": "emailHelp",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.attemptUploader.email) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.attemptUploader.email]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _withDirectives(_createElementVNode("input", {
                      type: "password",
                      class: "form-control",
                      id: "passwordu",
                      "aria-describedby": "emailHelp",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.attemptUploader.password) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.attemptUploader.password]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      class: "btn btn-success",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.loginUploader && _ctx.loginUploader(...args)))
                    }, "Acceder")
                  ])
                ], 32)
              ]),
              _createElementVNode("form", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("button", {
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args))),
                    type: "button",
                    name: "button",
                    id: "btn-ingresar",
                    class: "btn btn-primary btn-block"
                  }, "Login with Google ")
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}